import * as React from "react";
import { PluginHeader } from "./PluginHeader";
import { ActionBar } from "./ActionBar";
import { BottomTabs, type BottomTabItem, type ShellTabKey } from "./BottomTabs";
import { PluginToastHost } from "./PluginToast";

export type PluginShellProps = {
  title?: string;
  subtitle?: string;
  userName?: string;
  userEmail?: string;
  logoutPending?: boolean;
  onLogout?: () => void;
  onGoToPlatform?: () => void;
  incomingLoading?: boolean;
  cleanCopyLoading?: boolean;
  actionError?: string;
  onSaveAndUpload?: () => void;
  onCleanCopy?: () => void;
  activeTab: ShellTabKey;
  onTabChange: (tab: ShellTabKey) => void;
  tabs: BottomTabItem[];
  uploadOverlayTip?: string | null;
  /** When false, hide Save & upload / Clean copy and bottom tabs (unsupported doc). */
  showWorkspaceChrome?: boolean;
  children: React.ReactNode;
};

export const PluginShell: React.FC<PluginShellProps> = ({
  title,
  subtitle,
  userName,
  userEmail,
  logoutPending,
  onLogout,
  onGoToPlatform,
  incomingLoading,
  cleanCopyLoading,
  actionError,
  onSaveAndUpload,
  onCleanCopy,
  activeTab,
  onTabChange,
  tabs,
  uploadOverlayTip,
  showWorkspaceChrome = true,
  children,
}) => {
  const showOverlay = Boolean(uploadOverlayTip);

  return (
    <div className="taskpane-layout plugin-shell">
      <PluginHeader
        title={title}
        subtitle={subtitle}
        userName={userName}
        userEmail={userEmail}
        logoutPending={logoutPending}
        onLogout={onLogout}
        onGoToPlatform={onGoToPlatform}
      />
      {showWorkspaceChrome ? (
        <ActionBar
          incomingLoading={incomingLoading}
          cleanCopyLoading={cleanCopyLoading}
          onSaveAndUpload={onSaveAndUpload}
          onCleanCopy={onCleanCopy}
          error={actionError}
        />
      ) : null}
      <div className="plugin-shell-content thin-scroll">{children}</div>
      {showWorkspaceChrome ? (
        <BottomTabs active={activeTab} onChange={onTabChange} tabs={tabs} />
      ) : null}
      <PluginToastHost />
      {showOverlay ? (
        <div className="plugin-upload-overlay" role="status" aria-live="polite">
          <div className="plugin-upload-overlay__card">
            <div className="plugin-upload-overlay__spinner" aria-hidden />
            <div className="plugin-upload-overlay__tip">{uploadOverlayTip}</div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export type { ShellTabKey, BottomTabItem };
